// Shared constants/helpers for the Budget process (Gantt chart) feature.
// Backend contract: CONSOLE.md (paths, MultiLangStr shape, validation rules).
export const API_BASE = "api/v1/budget-process";

export const LANG_KEYS = ["uz_lat", "uz_cyr", "ru", "en", "kr"];

export const LANG_LABELS = {
  uz_lat: "O'zbekcha (lotin)",
  uz_cyr: "Ўзбекча (кирилл)",
  ru: "Русский",
  en: "English",
  kr: "Qoraqalpoqcha",
};

export const LANG_TABS = [
  {code: "uz_lat", tabLabel: "UZ"},
  {code: "uz_cyr", tabLabel: "UZ Krill"},
  {code: "ru", tabLabel: "RU"},
  {code: "en", tabLabel: "EN"},
  {code: "kr", tabLabel: "KR"},
];

export function emptyMultiLang() {
  return LANG_KEYS.reduce((acc, key) => {
    acc[key] = "";
    return acc;
  }, {});
}

// Merges a possibly-partial MultiLangStr from the API onto the full 5-key shape.
export function fillMultiLang(source) {
  return LANG_KEYS.reduce((acc, key) => {
    acc[key] = source?.[key] || "";
    return acc;
  }, {});
}

// Best-effort single string for table cells: admin's authoring language first.
export function displayLangText(multiLang) {
  if (!multiLang) return "";
  return multiLang.uz_lat || multiLang.uz_cyr || multiLang.ru || multiLang.en || multiLang.kr || "";
}

export const MONTH_NAMES_FULL = [
  "Yanvar", "Fevral", "Mart", "Aprel", "May", "Iyun",
  "Iyul", "Avgust", "Sentabr", "Oktabr", "Noyabr", "Dekabr",
];

export const MONTH_NAMES_SHORT = [
  "Yan", "Fev", "Mar", "Apr", "May", "Iyun",
  "Iyul", "Avg", "Sen", "Okt", "Noy", "Dek",
];

// abs(year, month) = year * 12 + month — CONSOLE.md 5.4 positioning math.
export function absMonth(year, month) {
  return year * 12 + month;
}

export function periodLabel(year, month, names = MONTH_NAMES_SHORT) {
  if (!year || !month) return "-";
  return `${names[month - 1] || month} ${year}`;
}

export function isPeriodOrderValid(startYear, startMonth, endYear, endMonth) {
  if (!startYear || !startMonth || !endYear || !endMonth) return true;
  return absMonth(endYear, endMonth) >= absMonth(startYear, startMonth);
}

// el-date-picker(type="month", value-format="YYYY-MM") <-> {year, month} bridging.
// The backend only stores year + month (days are irrelevant), so the console
// uses a true month picker (12-month grid + year stepper) per CONSOLE.md 5.2.
export function toPickerValue(year, month) {
  if (!year || !month) return "";
  return `${year}-${String(month).padStart(2, "0")}`;
}

export function fromPickerValue(value) {
  if (!value) return {year: null, month: null};
  // value is YYYY-MM; extract year and month for the backend.
  const parts = value.split("-").map(Number);
  return {year: parts[0], month: parts[1]};
}

// Preset palette for group colors — a balanced, professional spread of hues
// that read well as chart bars against a light background. Offered via the
// group dialog's swatch grid + a free hex input.
// #64748B matches the backend's own default when color is omitted.
export const GROUP_COLOR_PALETTE = [
  "#007791", "#0EA5E9", "#2563EB", "#7C3AED", "#DB2777",
  "#E11D48", "#F97316", "#EAB308", "#16A34A", "#14B8A6",
  "#0F766E", "#64748B",
];

export const DEFAULT_GROUP_COLOR = "#007791";
